// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__DndwX","truncatedText":"styles_truncatedText__IesJ0","fullText":"styles_fullText__30tpW","textContainer":"styles_textContainer__WYWvD"};